<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="questioner-content">
      <div class="container">
        <div class="questioner-inner">
          <div class="questioner-content full-width-page welcome-cont">
            <div class="question">
              <form class="form-section">
                <h2>Welcome to TTN Fleet Solutions</h2>
                <br>
                <br>
                <div class="row">
                  <div class="col-sm-12 left-part">
                    <div class="field-row">
                      <div class="field-col full-width">
                        <label class="blue">Company Name</label>
                        <input type="text" [disabled]="true" name="company-name"
                          [(ngModel)]="companySummaryInformation.companyName" placeholder="Company Name">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">First Name</label>
                        <input type="text" [disabled]="true" [(ngModel)]="companySummaryInformation.firstname"
                          name="First Name" placeholder="First Name">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Last Name</label>
                        <input type="text" [disabled]="true" [(ngModel)]="companySummaryInformation.lastname"
                          name="last-name" placeholder="Last Name">
                      </div>
                      <div class="field-col full-width">
                        <label class="blue">Email</label>
                        <input type="email" [disabled]="true" [(ngModel)]="companySummaryInformation.email" name="email"
                          placeholder="email">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Cell</label>
                        <input type="tel" [disabled]="true" [(ngModel)]="companySummaryInformation.phone" name="tel"
                          placeholder="Cell Phone">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Breakdown Team Phone</label>
                        <input type="tel" [disabled]="true" [(ngModel)]="companySummaryInformation.officePhone  "
                          name="office" placeholder="Office Phone">
                      </div>
                      <div class="field-col full-width">
                        <label class="blue">Billing Email</label>
                        <input type="email" [disabled]="true" [(ngModel)]="companySummaryInformation.billingEmail"
                          name="billing" placeholder="Billing Email">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Payment Terms</label>
                        <input type="number" [disabled]="true" name="Net30" placeholder="Net 30">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Credit Limit</label>
                        <input type="text" [disabled]="true" name="credit-limit" placeholder="$5000.00">
                      </div>
                      <div class="field-col full-width">
                        <p>
                          Credit Limits to be updated once approved by TTN Credit Team
                        </p>
                      </div>
                      <div class="field-col full-width">
                        <label class="blue">Authorization Towing & Mechanical Limit</label>
                        <input type="number" [disabled]="true" class="small-width-field" name="Authorization"
                          placeholder="$10000.00">
                      </div>
                      <div class="field-col full-width">
                        <p class="blue">When estimate exceeds limit, contact with user for approval will occur.</p>
                      </div>
                      <div class="field-col full-width">
                        <label class="blue">Authorization Tire Limit</label>
                        <input type="text" [disabled]="true" class="small-width-field" name="Authorization"
                          placeholder="18 Tire">
                      </div>
                      <div class="field-col full-width">
                        <p>Additional Approvers & Notification Protocols can be added from Profile Page. <br>
                          Default will be the user and contact information outlined above.
                        </p>
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Tow/Mechanical/Tire Service Fee</label>
                        <input type="number" [disabled]="true" name="tow" placeholder="$60.00">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Managed Shop Event Fee</label>
                        <input type="text" [disabled]="true" name="managed-shop-event" placeholder="Service Not Added">
                      </div>
                      <div class="field-col full-width">
                        <p class="blue">
                          Fee per event. No additional fees when additional providers selected to manage emergency
                          repairs
                        </p>
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Cargo Management fee</label>
                        <input type="text" [disabled]="true" name="cargo-mgmt-event" placeholder="Service Not Added">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Accident Management Fee</label>
                        <input type="text" [disabled]="true" name="managed-shop-event" placeholder="Service Not Added">
                      </div>
                      <div class="field-col half-width">
                        <label class="blue">Managed Maintenance Program</label>
                        <input type="text" [disabled]="true" name="managed-Maintenance-Program" placeholder="Service Not Added">
                      </div>
                      <div class="field-col full-width">
                        <p class="blue">
                          Additional services available with credit approval and update to service protocols
                        </p>
                      </div>
                    </div>
                    <br>
                  </div>
                </div>
              </form>
            </div>
            <div class="continue">
              <button (click)="goToSummarySecond()" class="common-btn"> Continue</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>